import axios from 'axios';

// Reads the signed-in employer's data through the employerData function (SEC-003.1) instead of
// querying Sanity from the browser. The Bearer token is added by utils/authInterceptor.js.
// Resolves to the query result and rejects on errors, like the Sanity client did.
export async function fetchEmployerData(request) {
  const res = await axios.post('/.netlify/functions/employerData', request);
  return res.data.result;
}
